/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { apigrouplist, apiinvite } from '@/api';
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import PopupPicker from "vux/src/components/popup-picker/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import Confirm from "vux/src/components/confirm/index.vue"; // this line is trasformed by vux-loader
import ScrollerList from '@/components/ScrollerList';
import ScrollerItem from '@/components/ScrollerList/ScrollerItem';
export default {
  components: {
    Popup: Popup,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    Group: Group,
    ScrollerList: ScrollerList,
    ScrollerItem: ScrollerItem,
    XButton: XButton,
    Confirm: Confirm
  },
  props: {},
  data: function data() {
    return {
      pageIndex: 0,
      pageSize: 10,
      list: [],
      groupName: '',
      showAddPerson: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user'])), {}, {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - (4 + 1) * fontSize - 50;
    }
  }),
  watch: {},
  methods: {
    onConfirm: function onConfirm(val) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return apiinvite({
                  phone: val
                }, 'post');
              case 2:
                res = _context.sent;
                if (res.success) {
                  _this.$vux.toast.text(i18n.tc("497"));
                } else {
                  _this.$vux.toast.text(res.message || '');
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    loadList: function loadList() {
      var _this2 = this;
      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (reset) {
        this.pageIndex = 0;
        this.$vux.loading.show({
          text: i18n.tc("206")
        });
      }
      return new Promise(function (resolve, reject) {
        var data = {
          pageIndex: _this2.pageIndex,
          pageSize: _this2.pageSize,
          keyword: _this2.keyword
        };
        apigrouplist(data).then(function (res) {
          setTimeout(function () {
            _this2.$vux.loading.hide();
          }, 300);
          if (res.success) {
            _this2.groupName = res.data.name;
            var list = res.data.list;
            if (!reset) {
              _this2.list = [].concat(_toConsumableArray(_this2.list), _toConsumableArray(list));
            } else {
              _this2.list = list;
            }
            resolve();
            // 判断是否有新数据
            if (list.length < _this2.pageSize) {
              _this2.$refs['linkPersonList'] && _this2.$refs['linkPersonList'].disablePullup();
            }
            if (list.length === _this2.pageSize) {
              _this2.$refs['linkPersonList'] && _this2.$refs['linkPersonList'].enablePullup();
            }
          }
        });
      });
    },
    resetList: function resetList() {
      this.list = [];
      this.pageIndex = 0;
      this.$refs['linkPersonList'] && this.$refs['linkPersonList'].enablePullup();
      this.loadList(true);
    },
    onPulldownLoading: function onPulldownLoading() {
      var _this3 = this;
      this.loadList(true).then(function () {
        _this3.$refs['linkPersonList'] && _this3.$refs['linkPersonList'].donePulldown();
      });
    },
    onPullupLoading: function onPullupLoading() {
      var _this4 = this;
      this.pageIndex = this.pageIndex + 1;
      this.loadList().then(function () {
        _this4.$refs['linkPersonList'] && _this4.$refs['linkPersonList'].donePullup();
      });
    }
  },
  created: function created() {
    this.loadList(true);
  }
};